var _defs, _polyline;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ee145cd2-24ae-4e4f-aff6-87d243df35b8",
    "data-name": "a56c983b-f153-4dfc-8655-dcf01a931069",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15.47 9.81",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".fcf03dbd-4e35-4aa0-a232-b6b8fa8056e2{fill:none;stroke-miterlimit:10;}"))), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "fcf03dbd-4e35-4aa0-a232-b6b8fa8056e2",
    points: "0.38 9.48 8.01 0.78 15.09 9.48"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpArrow);
export default __webpack_public_path__ + "static/media/up-arrow.4f5e84dedcc696047e86beec6d150ffa.svg";
export { ForwardRef as ReactComponent };